export default function PageHeader({ title, subtitle, action, testId, stackOnMobile = false, context, showTitle = false }) {
    if (showTitle) {
        return (
            <div data-testid={testId || "page-header"}
                className={`${stackOnMobile ? "flex flex-col items-stretch gap-4 sm:flex-row sm:items-end sm:justify-between sm:gap-6" : "flex items-end justify-between gap-6"} mb-8 pb-6 border-b border-neutral-200`}>
                <div>
                    <h1 className="font-display text-4xl sm:text-5xl font-extrabold tracking-tight leading-[1.05]">{title}</h1>
                    {subtitle && <p className="mt-3 text-sm text-neutral-500 max-w-xl">{subtitle}</p>}
                </div>
                {action}
            </div>
        );
    }
    // Restaurant desktop: no large visible title or tagline; the page keeps an accessible h1.
    const visible = context || action;
    return (
        <div data-testid={testId || "page-header"}
            className={visible ? `${stackOnMobile ? "flex flex-col items-stretch gap-3 sm:flex-row sm:items-center sm:justify-between" : "flex flex-wrap items-center justify-between gap-3"} mb-5` : ""}>
            <h1 className="sr-only">{title}</h1>
            {context ? <p className="text-sm font-semibold text-neutral-800" data-testid="page-header-context">{context}</p> : <span aria-hidden="true" />}
            {action}
        </div>
    );
}
